/**
 * Removes all whitespace characters from a formula string
 */
export const removeSpaces = (formula: string): string => formula.replace(/\s+/g, '');

/**
 * Filters out entries with empty or whitespace-only formulas
 */
export const filterEmptyFormulas = (formulas: { [columnName: string]: string }): Array<[string, string]> => {
  return Object.entries(formulas).filter(([, formula]) => formula.trim() !== '');
};

/**
 * Processes formulas by removing spaces and filtering empty values
 * Returns a clean object with non-empty formulas
 */
export const processFormulas = (formulas: {
  [columnName: string]: string;
}): { [columnName: string]: string } => {
  return Object.fromEntries(
    Object.entries(formulas)
      .map(([key, formula]) => [key, removeSpaces(formula)])
      .filter(([, formula]) => formula !== ''),
  );
};
